import { IColumn } from "../../../shared/components/normal-table/normal-table";
import "./entity-captures.scss";
import ListPage from "../../components/list-page/list-page";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  }
];

const EntityCapturesList = () => {
  return (
    <div className="entityCaptureList">
      <ListPage
        title={"Entity capture screens"}
        defaultSortCol={"name"}
        columns={columns}
        dataUrl= {{
          url: "captures",
          queryString: "datamodel_type=entity",
          backend: "manager"
        }}
        deleteUrl={{
          url: "captures",
          queryString: "datamodel_type=entity",
          backend: "manager"
        }}
      />
    </div>
  );
};

export default EntityCapturesList;